let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("evtYc")).then(() => parcelRequire('8ZR9n'));